(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 989px)';
  var mobileQuery = window.matchMedia(MOBILE_QUERY);
  var actionBarQuery = window.matchMedia('(max-width: 768px)');
  var parityStarted = false;
  var sectionLoadBound = false;

  function isMobile() {
    return mobileQuery.matches;
  }

  function visibleFocusable(root) {
    if (!root) return [];
    return Array.prototype.slice.call(root.querySelectorAll(
      'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'
    )).filter(function (element) {
      return !element.hidden && element.getAttribute('aria-hidden') !== 'true' && element.getClientRects().length > 0;
    });
  }

  function injectShadowParity(root) {
    if (!root || !root.shadowRoot) return;
    var shadow = root.shadowRoot;
    if (!shadow.querySelector('[data-jr-mobile-parity-shadow]')) {
      var style = document.createElement('style');
      style.setAttribute('data-jr-mobile-parity-shadow', '');
      style.textContent = [
        '@media(max-width:989px){',
        ':host{display:block;max-width:100%;overflow-x:clip}',
        '*,*::before,*::after{box-sizing:border-box}',
        'img,video,iframe,canvas,svg{max-width:100%}',
        'input:not([type="checkbox"]):not([type="radio"]),select,textarea{font-size:16px!important}',
        'button,a,input,select,textarea,[role="button"],[role="slider"]{touch-action:manipulation}',
        '[id]{scroll-margin-top:84px}',
        ':focus-visible{outline:2px solid #cf1235!important;outline-offset:3px!important}',
        '.tile__a,.int__a,.dbrow__a,.row__a{opacity:1!important;visibility:visible!important;transform:none!important}',
        'table{max-width:100%}',
        'iframe{width:100%}',
        '}'
      ].join('');
      shadow.appendChild(style);
    }
    Array.prototype.forEach.call(shadow.querySelectorAll('*'), injectShadowParity);
  }

  function scanShadowRoots(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(target.querySelectorAll('*'), injectShadowParity);
  }

  function reconcileFixedTools() {
    var actionBar = document.querySelector('.jrx-mbar');
    var barIsVisible = Boolean(actionBar && window.matchMedia('(max-width: 768px)').matches);
    document.body.classList.toggle('jr-mobile-actionbar-active', barIsVisible);
    var compactContacts = document.querySelectorAll('.jr-mobile-sticky-contact');
    Array.prototype.forEach.call(compactContacts, function (contact) {
      if (barIsVisible) {
        contact.setAttribute('aria-hidden', 'true');
        contact.setAttribute('inert', '');
      } else {
        contact.removeAttribute('aria-hidden');
        contact.removeAttribute('inert');
      }
    });
  }

  function addMobileMenuSocials() {
    var menuTarget = document.querySelector('.gh-cta__inner');
    var desktopRail = document.querySelector('.grail');
    if (!menuTarget || !desktopRail || menuTarget.querySelector('.jr-mobile-menu-social')) return;

    var links = desktopRail.querySelectorAll('a[href]');
    if (!links.length) return;

    var group = document.createElement('nav');
    group.className = 'jr-mobile-menu-social';
    group.setAttribute('aria-label', 'Social media');
    Array.prototype.forEach.call(links, function (link) {
      var href = link.getAttribute('href');
      if (!href || href === '#') return;
      var clone = link.cloneNode(true);
      clone.removeAttribute('class');
      clone.addEventListener('click', function () {
        var menu = document.getElementById('ghNav');
        var burger = document.getElementById('ghBurger');
        if (menu) menu.classList.remove('open');
        document.body.classList.remove('gh-menu-open');
        if (burger) burger.setAttribute('aria-expanded', 'false');
      });
      group.appendChild(clone);
    });
    if (group.children.length) menuTarget.appendChild(group);
  }

  function installMobileMenuFocusManagement() {
    var menu = document.getElementById('ghNav');
    var burger = document.querySelector('[aria-controls="ghNav"], .gh-burger, .gh-menu-toggle');
    if (!menu || menu.dataset.jrParityFocus === 'true') return;
    menu.dataset.jrParityFocus = 'true';
    if (isMobile()) menu.setAttribute('aria-hidden', menu.classList.contains('open') ? 'false' : 'true');
    else menu.removeAttribute('aria-hidden');
    var lastFocused = null;
    var wasOpen = menu.classList.contains('open') || document.body.classList.contains('gh-menu-open');

    function syncMenuState() {
      var open = menu.classList.contains('open') || document.body.classList.contains('gh-menu-open');
      if (!isMobile()) {
        menu.removeAttribute('aria-hidden');
        wasOpen = open;
        return;
      }
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (open && !wasOpen) {
        lastFocused = document.activeElement;
        window.setTimeout(function () {
          var focusable = visibleFocusable(menu);
          if (focusable[0]) focusable[0].focus({ preventScroll: true });
        }, 80);
      } else if (!open && wasOpen && lastFocused && typeof lastFocused.focus === 'function') {
        lastFocused.focus({ preventScroll: true });
        lastFocused = null;
      }
      wasOpen = open;
    }

    new MutationObserver(syncMenuState).observe(menu, { attributes: true, attributeFilter: ['class'] });
    new MutationObserver(syncMenuState).observe(document.body, { attributes: true, attributeFilter: ['class'] });

    document.addEventListener('keydown', function (event) {
      if (!isMobile() || event.key !== 'Tab') return;
      var open = menu.classList.contains('open') || document.body.classList.contains('gh-menu-open');
      if (!open) return;
      var focusable = visibleFocusable(menu);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (burger) burger.setAttribute('aria-haspopup', 'dialog');
    window.addEventListener('resize', syncMenuState, { passive: true });
  }

  function enhanceServiceStrip() {
    var strip = document.getElementById('strip__strip');
    if (!strip || strip.dataset.jrParity === 'true') return;
    strip.dataset.jrParity = 'true';
    var columns = Array.prototype.slice.call(strip.querySelectorAll('.col'));
    var backgrounds = {};
    Array.prototype.forEach.call(strip.querySelectorAll('.strip__bg'), function (background) {
      backgrounds[background.dataset.key] = background;
    });

    function activate(column) {
      Array.prototype.forEach.call(columns, function (item) {
        var active = item === column;
        item.classList.toggle('is-touch-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var key = column && column.dataset.bg ? column.dataset.bg : 'default';
      Object.keys(backgrounds).forEach(function (name) {
        backgrounds[name].classList.toggle('is-on', name === key);
      });
    }

    columns.forEach(function (column) {
      if (!column.hasAttribute('tabindex')) column.tabIndex = 0;
      column.setAttribute('role', 'button');
      column.setAttribute('aria-pressed', 'false');
      column.addEventListener('pointerup', function (event) {
        if (event.pointerType !== 'mouse' || isMobile()) activate(column);
      });
      column.addEventListener('focus', function () { activate(column); });
      column.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate(column);
        }
      });
    });
  }

  function enhanceBeforeAfter() {
    var slider = document.getElementById('concierge__ba');
    if (!slider || slider.dataset.jrParity === 'true') return;
    slider.dataset.jrParity = 'true';
    slider.tabIndex = slider.hasAttribute('tabindex') ? slider.tabIndex : 0;
    slider.setAttribute('role', 'slider');
    slider.setAttribute('aria-label', 'Before and after property presentation comparison');
    slider.setAttribute('aria-valuemin', '0');
    slider.setAttribute('aria-valuemax', '100');
    slider.setAttribute('aria-valuenow', '50');
    slider.style.touchAction = 'pan-y';
    var dragging = false;

    function setPercent(percent) {
      var value = Math.max(0, Math.min(100, Math.round(percent)));
      slider.style.setProperty('--p', value / 100);
      slider.setAttribute('aria-valuenow', String(value));
    }

    function setFromClientX(clientX) {
      var rect = slider.getBoundingClientRect();
      if (!rect.width) return;
      setPercent(((clientX - rect.left) / rect.width) * 100);
    }

    slider.addEventListener('pointerdown', function (event) {
      dragging = true;
      if (slider.setPointerCapture) slider.setPointerCapture(event.pointerId);
      setFromClientX(event.clientX);
    });
    slider.addEventListener('pointermove', function (event) {
      if (!dragging) return;
      setFromClientX(event.clientX);
    });
    slider.addEventListener('pointerup', function (event) {
      dragging = false;
      if (slider.releasePointerCapture && slider.hasPointerCapture && slider.hasPointerCapture(event.pointerId)) {
        slider.releasePointerCapture(event.pointerId);
      }
    });
    slider.addEventListener('pointercancel', function () { dragging = false; });
    slider.addEventListener('keydown', function (event) {
      var current = Number(slider.getAttribute('aria-valuenow')) || 50;
      var next = current;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') next -= 5;
      else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') next += 5;
      else if (event.key === 'PageDown') next -= 10;
      else if (event.key === 'PageUp') next += 10;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = 100;
      else return;
      event.preventDefault();
      setPercent(next);
    });
  }

  function labelListingCards() {
    Array.prototype.forEach.call(document.querySelectorAll('#s-listings .card'), function (card) {
      if (card.getAttribute('aria-label')) return;
      var details = Array.prototype.map.call(card.querySelectorAll('.reveal__price,.reveal__addr,.reveal__city,.reveal__stats'), function (element) {
        return (element.textContent || '').replace(/\s+/g, ' ').trim();
      }).filter(Boolean);
      if (details.length) card.setAttribute('aria-label', details.join(', '));
    });
  }

  function enhanceHorizontalRails() {
    if (!isMobile()) return;
    var selectors = [
      '#s-listings .grid',
      '#s-media .media__grid',
      '#s-contact .areas',
      '.cells.c3',
      '.cells.c4',
      '.tiles__grid'
    ];

    function process(scope) {
      if (!scope || !scope.querySelectorAll) return;
      Array.prototype.forEach.call(scope.querySelectorAll(selectors.join(',')), function (rail) {
        if (rail.scrollWidth <= rail.clientWidth + 4 || rail.dataset.jrMobileRail === 'true') return;
        rail.dataset.jrMobileRail = 'true';
        rail.setAttribute('data-jr-mobile-rail', 'true');
        rail.tabIndex = 0;
        rail.setAttribute('aria-label', rail.getAttribute('aria-label') || 'Horizontally scrollable content');
        rail.addEventListener('keydown', function (event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          rail.scrollBy({ left: (event.key === 'ArrowRight' ? 1 : -1) * Math.max(220, rail.clientWidth * 0.8), behavior: 'smooth' });
        });
      });
      Array.prototype.forEach.call(scope.querySelectorAll('*'), function (element) {
        if (element.shadowRoot) process(element.shadowRoot);
      });
    }

    process(document);
  }

  function revealFailsafe() {
    if (!isMobile()) return;
    window.setTimeout(function () {
      function revealVisible(scope) {
        if (!scope || !scope.querySelectorAll) return;
        Array.prototype.forEach.call(scope.querySelectorAll('.rv,.rise,[data-rise],.pc-in'), function (element) {
          var rect = element.getBoundingClientRect();
          if (rect.bottom < -120 || rect.top > window.innerHeight + 120) return;
          var style = window.getComputedStyle(element);
          if (style.opacity === '0' || style.visibility === 'hidden') {
            element.classList.add('in', 'rise-in', 'jr-mobile-parity-visible');
          }
        });
        Array.prototype.forEach.call(scope.querySelectorAll('*'), function (element) {
          if (element.shadowRoot) revealVisible(element.shadowRoot);
        });
      }
      revealVisible(document);
    }, 2800);
  }

  function initialize() {
    addMobileMenuSocials();
    installMobileMenuFocusManagement();
    enhanceServiceStrip();
    enhanceBeforeAfter();
    labelListingCards();
    enhanceHorizontalRails();
    reconcileFixedTools();
    scanShadowRoots(document);
    revealFailsafe();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
        if (node.nodeType !== 1) return;
        injectShadowParity(node);
        scanShadowRoots(node);
      });
    });
    reconcileFixedTools();
  });

  function start() {
    if (parityStarted || !isMobile()) {
      reconcileFixedTools();
      return;
    }
    parityStarted = true;
    initialize();
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { scanShadowRoots(document); }, 500);
    window.setTimeout(function () { scanShadowRoots(document); enhanceHorizontalRails(); }, 1800);
    window.setTimeout(function () { observer.disconnect(); }, 12000);
    if (!sectionLoadBound) {
      sectionLoadBound = true;
      document.addEventListener('shopify:section:load', function (event) {
        if (!isMobile()) return;
        scanShadowRoots(event.target || document);
        window.setTimeout(function () { scanShadowRoots(event.target || document); }, 100);
      });
    }
  }

  function boot() {
    if (isMobile()) start();
    else reconcileFixedTools();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  function handleResponsiveChange() {
    if (isMobile()) start();
    reconcileFixedTools();
    enhanceHorizontalRails();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', handleResponsiveChange);
    actionBarQuery.addEventListener('change', handleResponsiveChange);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(handleResponsiveChange);
    actionBarQuery.addListener(handleResponsiveChange);
  }
})();
